import { Col, Container, Row } from "react-bootstrap";

const Intro = () => {
  return (
    <>
      <Container fluid className="intro_top text-center pt-5 pb-5 m-0">
        <Row className="m-0">
          <Col className="m-0">
            <h1>La pick up que va a redefinirlo todo</h1>
            <h2>
              La Nueva Generación de la Ranger fue diseñada 100% con el ADN de la Raza Fuerte: es una pickup{" "}
              <br className="d-md-block d-none" />
              robusta e imponente, y a la vez, con gran cantidad de equipamiento tecnológico.
            </h2>
          </Col>
        </Row>
      </Container>
      <div className="divisorIntro"></div>
    </>
  );
};

export default Intro;
